import IExtension from "./IExtension";
import {Naja} from "naja";

const PUSHED_CLASS = 'offcanvas-pushed';
const NESTED_CLASS = 'offcanvas-nested';
const NESTED_BACKDROP_CLASS = 'offcanvas-backdrop-nested';
const PUSH_TRANSITION_MS = 350;

export default class OffcanvasExtension implements IExtension {
    initialize(naja: Naja): void {
        document.addEventListener('show.bs.offcanvas', event => this.handleShow(event));
        document.addEventListener('hide.bs.offcanvas', event => this.handleHide(event));
        document.addEventListener('hidden.bs.offcanvas', event => this.handleHidden(event));
    }

    private handleShow(event: Event): void {
        const offcanvas = event.target;
        if (!(offcanvas instanceof HTMLElement) || !offcanvas.classList.contains('offcanvas')) {
            return;
        }

        const parent = Array.from(document.querySelectorAll<HTMLElement>('.offcanvas.show, .offcanvas.showing'))
            .find(el => el !== offcanvas);
        if (!parent) {
            return;
        }

        const shift = Math.min(offcanvas.offsetWidth, Math.max(parent.getBoundingClientRect().left, 0));

        parent.classList.add(PUSHED_CLASS);
        parent.style.right = `${shift}px`;

        offcanvas.classList.add(NESTED_CLASS);
        offcanvas.dataset.pushesParent = parent.id;

        window.setTimeout(() => {
            const backdrop = offcanvas.parentElement?.querySelector(
                ':scope > .offcanvas-backdrop:not(.' + NESTED_BACKDROP_CLASS + ')'
            );
            backdrop?.classList.add(NESTED_BACKDROP_CLASS);
        });
    }

    private handleHide(event: Event): void {
        const offcanvas = event.target;
        if (!(offcanvas instanceof HTMLElement) || !offcanvas.classList.contains('offcanvas')) {
            return;
        }

        const parentId = offcanvas.dataset.pushesParent;
        if (!parentId) {
            return;
        }

        const parent = document.getElementById(parentId);
        if (!parent) {
            return;
        }

        let unpushed = false;
        const unpush = () => {
            if (unpushed) {
                return;
            }
            unpushed = true;
            parent.classList.remove(PUSHED_CLASS);
        };
        parent.addEventListener('transitionend', function onTransitionEnd(e) {
            if (e.propertyName !== 'right') {
                return;
            }
            parent.removeEventListener('transitionend', onTransitionEnd);
            unpush();
        });
        window.setTimeout(unpush, PUSH_TRANSITION_MS);
        parent.style.right = '';
    }

    private handleHidden(event: Event): void {
        const offcanvas = event.target;
        if (!(offcanvas instanceof HTMLElement) || !offcanvas.classList.contains('offcanvas')) {
            return;
        }

        offcanvas.classList.remove(NESTED_CLASS);
        delete offcanvas.dataset.pushesParent;
    }
}
